import React, {useState, useEffect} from "react";
import { Container } from "@mui/material";
import FindWishList from "../components/FindWishList";
import FixedBottomNavigation from "../components/FixedBottomNavigation";
import HeaderBar from "../components/HeaderBar"; // 
import { supabase } from "../supabaseClient";

const WishList = () => {
  const [user, setUser] = useState(null); // ✅ 사용자 정보 상태 추가
  
  useEffect(() => {
    let isMounted = true; // ✅ 컴포넌트가 언마운트되었는지 체크

    // ✅ onAuthStateChange 구독 및 클린업 처리
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_, session) => {
      if (isMounted){
        setUser(session?.user ?? null);
      }
    });

    return () => {
      isMounted = false; // ✅ 언마운트 시 API 호출 막기
      subscription?.unsubscribe(); // ✅ 구독 해제
    };
  }, []);

  return (
    <Container sx={{ pb: 7, pt: 7, }}>
      {/* 🔹 헤더 영역 */}
      <HeaderBar title="내 위시리스트" showBack />

      {user ? <FindWishList userId={user.id} /> : <p>사용자 정보를 불러오는 중...</p>}

      <FixedBottomNavigation />
    </Container>
  );
};

export default WishList;
